import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import RateSheetFileNameComponent from "./RateSheetFileNameComponent";
import CustomSelect from "./common/CustomSelect";
import CustomSwitch from "./common/CustomSwitch";
import { RateSheetFormat } from "../services/RateTemplateService";

interface GeneralDetailsRatesheetProps {
  rateTemplate: {
    rateSheetFileName: string;
    rateSheetFormat: string;
    includeLogo: boolean;
  };
  handleFieldChange: (field: keyof GeneralDetailsRatesheetProps["rateTemplate"], value: string) => void;
  handleCustomFormChange: (field: keyof GeneralDetailsRatesheetProps["rateTemplate"], value: string | boolean) => void;
}

const GeneralDetailsRatesheet: React.FC<GeneralDetailsRatesheetProps> = ({
  rateTemplate,
  handleFieldChange,
  handleCustomFormChange,
}) => {
  const rateSheetFormatOptions = Object.entries(RateSheetFormat)
    .filter(([key, value]) => typeof value === "number")
    .map(([key]) => ({
      label: key,
      value: key,
    }));

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      alignItems="center"
      gap={1}
    >
      <Box flex={{ xs: "10%", sm: "50%" }}>
        <RateSheetFileNameComponent
          textFieldValue={rateTemplate.rateSheetFileName}
          selectValue={rateTemplate.rateSheetFileName.toString()}
          onTextFieldChange={(value) =>
            handleFieldChange("rateSheetFileName", value)
          }
          onSelectChange={(value) =>
            handleFieldChange("rateSheetFileName", value)
          }
        />
      </Box>
      <Box flex={{ xs: "70%", sm: "60%" }} mb={4}>
        <CustomSelect
          label="Rate Sheet Format"
          fullWidth
          size={isMobile ? "large" : "medium"}
          value={rateTemplate.rateSheetFormat}
          options={rateSheetFormatOptions}
          onChange={(value: string | number | (string | number)[]) =>
            handleCustomFormChange("rateSheetFormat", value as string)
          }

        />
      </Box>
    </Box>
  );
};

export default GeneralDetailsRatesheet;